const stats = [
  {
    icon: 'ri-line-chart-line',
    value: '+20–25%',
    title: 'Рост ROI',
    text: 'Бренды, использующие персонализированные ИИ-видео, фиксируют существенный рост окупаемости инвестиций.',
  },
  {
    icon: 'ri-eye-line',
    value: 'x2',
    title: 'Двойное вовлечение',
    text: 'Видео с аватарами удерживают внимание в 2 раза лучше, чем обычные статичные посты.',
  },
  {
    icon: 'ri-scissors-cut-line',
    value: '-90%',
    title: 'Экономия бюджета',
    text: 'Создание контента через цифрового двойника обходится в разы дешевле традиционного видеопроизводства.',
  },
];

export default function AIAvatarBenefits() {
  return (
    <section className="py-14 sm:py-28 bg-gradient-to-br from-[#1A2B4C] to-[#253D6B]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 border border-white/20 mb-5">
            <i className="ri-trophy-line text-[#C5A880] text-sm"></i>
            <span className="text-white/80 text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Финансовые показатели
            </span>
          </div>
          <h2 className="text-xl sm:text-4xl font-['Playfair_Display'] font-bold text-white mb-4 leading-tight">
            Почему это выгодно
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-8">
          {stats.map((s) => (
            <div key={s.title} className="bg-white/08 border border-white/15 rounded-2xl p-6 sm:p-10 text-center hover:bg-white/12 transition-colors duration-300">
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center rounded-xl bg-[#C5A880]/20 border border-[#C5A880]/30 mx-auto mb-4 sm:mb-5">
                <i className={`${s.icon} text-xl sm:text-2xl text-[#C5A880]`}></i>
              </div>
              <div className="text-3xl sm:text-5xl font-bold text-[#C5A880] font-['Playfair_Display'] mb-2 sm:mb-3">
                {s.value}
              </div>
              <h3 className="text-base font-bold text-white font-['Playfair_Display'] mb-2 sm:mb-3">
                {s.title}
              </h3>
              <p className="text-white/60 text-sm leading-relaxed font-['Montserrat'] text-center">
                {s.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
